"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diseaseTypes = exports.SdcIdTypeEnum = void 0;
var SdcIdTypeEnum = exports.SdcIdTypeEnum = [{
  'label': '身份证',
  'value': 'id_card'
}, {
  'label': '旧身份证',
  'value': 'old_id_card'
}, {
  'label': '护照',
  'value': 'passport'
}, {
  'label': '台胞证',
  'value': 'ttrmt'
}, {
  'label': '香港护照',
  'value': 'hong_kong_passport'
}, {
  'label': '出生证明',
  'value': 'birth_certificate'
}, {
  'label': '其他',
  'value': 'other'
}, {
  'label': '外国人永久居留身份证',
  'value': 'foreigner_prid'
}, {
  'label': '户口',
  'value': 'hukou'
}, {
  'label': '往来港澳通行证',
  'value': 'hkmo_pass '
}, {
  'label': '大陆去港澳通行证',
  'value': 'mtp'
}, {
  'label': '澳门身份证',
  'value': 'macau_identity_card'
}, {
  'label': '台湾身份证',
  'value': 'taiwan_resident_identity_card'
}];
var diseaseTypes = exports.diseaseTypes = [{
  'label': '神经康复',
  'value': '神经康复',
  'children': [{
    'label': '脑卒中',
    'value': '脑卒中'
  }, {
    'label': '脊髓损伤',
    'value': '脊髓损伤'
  }, {
    'label': '帕金森',
    'value': '帕金森'
  }, {
    'label': '脊髓炎',
    'value': '脊髓炎'
  }, {
    'label': '周围神经损伤',
    'value': '周围神经损伤'
  }, {
    'label': '阿尔兹海默症（轻、中度）',
    'value': '阿尔兹海默症（轻、中度）'
  }]
}, {
  'label': '骨科康复',
  'value': '骨科康复',
  'children': [{
    'label': '人工关节置换术',
    'value': '人工关节置换术'
  }, {
    'label': '骨折',
    'value': '骨折'
  }]
}, {
  'label': '内科疾病',
  'value': '内科疾病',
  'children': [{
    'label': '冠心病',
    'value': '冠心病'
  }, {
    'label': '慢性支气管炎',
    'value': '慢性支气管炎'
  }, {
    'label': '慢性阻塞性肺病',
    'value': '慢性阻塞性肺病'
  }, {
    'label': '原发性高血压',
    'value': '原发性高血压'
  }, {
    'label': '慢性充血性心力衰竭',
    'value': '慢性充血性心力衰竭'
  }, {
    'label': '糖尿病',
    'value': '糖尿病'
  }]
}, {
  'label': '外科疾病',
  'value': '外科疾病',
  'children': [{
    'label': '烧伤',
    'value': '烧伤'
  }, {
    'label': '外科急性感染',
    'value': '外科急性感染'
  }]
}, {
  'label': '孕产康复',
  'value': '孕产康复',
  'children': [{
    'label': '孕产',
    'value': '孕产'
  }]
}, {
  'label': '癌症康复',
  'value': '癌症康复',
  'children': [{
    'label': '肺癌',
    'value': '肺癌'
  }, {
    'label': '乳腺癌',
    'value': '乳腺癌'
  }, {
    'label': '甲状腺癌',
    'value': '甲状腺癌'
  }, {
    'label': '宫颈/卵巢癌',
    'value': '宫颈/卵巢癌'
  }, {
    'label': '其他癌症',
    'value': '其他癌症'
  }]
}, {
  'label': '疼痛康复',
  'value': '疼痛康复',
  'children': [{
    'label': '肌骨疼痛',
    'value': '肌骨疼痛'
  }]
}];